'use client';

import { KitViewProvider } from '@styleglide/kit-view-provider';

export function StyleGlideProvider() {
  return <KitViewProvider />;
}
